import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import NavBar from "../../../../Member/Navbar/Navbar";
function getSteps() {
  return ["Ajouter un Profile", "Ajouter un Cabinet", "Message"];
}

const StepperAdmin = (props) => {
  const { count } = props;

  const steps = getSteps();

  return (
    <>
      <Stepper activeStep={count} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </>
  );
};

export default StepperAdmin;
